import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const StyledLine = styled.div`
  height: 1px;
  background-color: ${withVar(DesignToken.SurfaceTertiaryDefault)};
  width: 100%;
  margin: 8px 0;
`;

// FIXME: Fix this the next time the file is edited.

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const Line = () => <StyledLine />;
